import { RefreshCw } from "lucide-react";
import { useId } from "react";
import { useTranslation } from "react-i18next";

import { Switch } from "@/components/ui/switch";
import { useAutoAcceptPayments } from "@/features/payments/hooks/use-auto-accept-payments";
import { usePaymentSetupStatus } from "@/features/payments/hooks/use-payment-setup-status";

export const AutoAcceptSetting = () => {
  const { t } = useTranslation();
  const switchId = useId();

  const { hasPayoutAccount } = usePaymentSetupStatus();
  const { isEnabled, isLoading, isSaving, pendingValue, setEnabled } =
    useAutoAcceptPayments();

  if (!hasPayoutAccount) {
    return null;
  }

  return (
    <div data-test-id="auto-accept" className="flex items-center gap-x-4 py-2">
      <RefreshCw aria-hidden="true" />
      <label htmlFor={switchId} className="leading-loose flex-1">
        {t("auto_accept_payments_title")}
      </label>
      <Switch
        id={switchId}
        checked={pendingValue ?? isEnabled}
        disabled={isLoading || isSaving}
        onCheckedChange={(checked) => setEnabled(checked)}
      />
    </div>
  );
};
